<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/getOrders';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.OrderDescription_2')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[

        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
                    ]
            },
             {
                title:`${this.$t('onlineDoc.请求参数')}`,
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
             {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: `${this.$t('onlineDoc.客户编码（联系出货网点提供）')}`},
                {name: "digest",type: "String(50)",require: "Y",normal: `${this.$t('onlineDoc.明文密码:H5CD3zE6')}`,describe: `${this.$t('onlineDoc.sign')}`},
                {name: "command",type: "int(5)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.查询命令')}`},
                {name: "serialNumber",type: "List[]",require: "N",normal: "",describe:`${this.$t('onlineDoc.command')}`},

                {name: "startDate",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.startDate')}`},
                {name: "endDate",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.endDate')}`},
                {name: "status",type: "int(10)",require: "N",normal: "",describe:  `${this.$t('onlineDoc.status')}`},
                {name: "current",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.command = 3 时必填')}`},
                {name: "size",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.command = 3 时必填')}`},
                {name: "invoiceNumber",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.invoceNumber')}`},
                {name: "packingNumber",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.packingNumber')}`},
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`},
                  ]
            },

            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "lastCenterName",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.集包地')}`},
                  {name: "orderNumber",type: "long",require: "Y",normal: "",describe: `${this.$t('onlineDoc.系统订单号')}`},
                  {name: "txlogisticId",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单号-客户自己系统的订单号')}`},
                  // {name: "billCode",type: "String",require: "Y",normal: "",describe: "运单号"},
                  {name: "expressType",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ExpressType')}`},
                  {name: "orderStatus",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.订单状态')}`},
                  {name: "orderType",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.OrderType')}`},
                  {name: "serviceType",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.服务类型')}`},
                  {name: "deliveryType",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.派送类型')}`},
                  {name: "sortingCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.三段码')}`},
                  {name: "sumFreight",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.参考总运费')}`},
                  {name: "sender",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件信息对象')}`},
                  {name: "receiver",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件信息对象')}`},

                  {name: "sendStartTime",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.LC_pick_up_start_time')}`},
                  {name: "sendEndTime",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.CLC_door_to_door_end_time')}`},
                  {name: "goodsType",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.itemtType')}`},
                  {name: "length",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.Length')}`},
                  {name: "width",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.Width')}`},
                  {name: "height",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.Height')}`},
                  {name: "volume",type: "int",require: "N",normal: "",describe: `${this.$t('onlineDoc.volume')}`},
                  {name: "weight",type: "int",require: "Y",normal: "",describe: `${this.$t('onlineDoc.Weight')}`},
                  {name: "totalQuantity",type: "int",require: "N",normal: "默认1",describe: `${this.$t('onlineDoc.包裹总件数')}`},
                  {name: "itemsValue",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.代收货款金额 (数值型)')}`},
                  {name: "priceCurrency",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.collectionPayment')}`},
                  {name: "offerFee",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.offerFee')}`},
                  {name: "remark",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.备注')}`},
                  {name: "items",type: "List",require: "N",normal: "",describe: `${this.$t('onlineDoc.商品信息列表')}`},
                  {name: "createOrderTime",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.订单创建时间')}`}
                ]
            },

            {
              title:`${this.$t('onlineDoc.sender类型说明')}`,
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件人姓名')}`},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件公司')}`},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件邮编')}`},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件邮箱')}`},
                {name: "taxNumber",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.taxNumber')}`},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.SendingMobilePhone')}`},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.SendingPhoneNumber')}`},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "CHN",describe: `${this.$t('onlineDoc.ThreeCharacterSending')}`},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件酋长国')}`},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.寄件区域')}`},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.寄件街道')}`},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ShippingDetailedAddress')}`},
                {name: "longitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.经度New')}`},
                {name: "latitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.纬度New')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.receiver类型说明')}`,
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件人姓名')}`},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件公司')}`},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件邮编')}`},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件邮箱')}`},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ReceivingMobilephone')}`},
                {name: "taxNumber",type: "String(100)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.taxNumber')}`},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ReceivingPhoneNumber')}`},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "CHN",describe: `${this.$t('onlineDoc.ThreeCharacterRecipient')}`},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件酋长国')}`},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.收件区域')}`},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: `${this.$t('onlineDoc.收件街道')}`},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: `${this.$t('onlineDoc.ReceivingDetailedAddress')}`},
                {name: "longitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.经度New')}`},
                {name: "latitude",type: "String(10)",require: "N",normal: "",describe: `${this.$t('onlineDoc.纬度New')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.items类型说明')}`,
              value:[
                {name: "itemType",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品类型')}`},
                {name: "itemName",type: "String(30)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品名称')}`},
                {name: "chineseName",type: "String(60)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品中文名称')}`},
                {name: "englishName",type: "String(60)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品英文名称')}`},
                {name: "number",type: "int(4)",require: "N",normal: "",describe: `${this.$t('onlineDoc.cases')}`},
                {name: "itemValue",type: "String(20)",require: "N",normal: "",describe: `${this.$t('onlineDoc.申报价值(数值型)')}`},
                {name: "priceCurrency",type: "String(20)",require: "N",normal: "",describe: `${this.$t('onlineDoc.priceCurrency')}`},
                {name: "desc",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.物品描述')}`},
                {name: "itemUrl",type: "String(100)",require: "N",normal: "",describe: `${this.$t('onlineDoc.商品URL')}`}
              ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {
      "serialNumber":["1598516207047"],
      "digest":"x+naV5ZQWEddcrRlxjX04Q==",
      "customerCode":"J0086093125",
      "command":1
      }`,
        //返回示例
        responseCode: JSON.parse(
          `{
    "code": "1",
    "msg": "success",
    "data": [
        {
            "countryCode": null,
            "customerId": "1598516207047",
            "txlogisticId": null,
            "billCode": "YL1234567890123",
            "expressType": null,
            "orderType": "1",
            "serviceType": null,
            "deliveryType": null,
            "sender": {
                "name": "李白",
                "company": "天美工作室",
                "postCode": "518000",
                "mailBox": "ant_li@qq.com",
                "mobile": "12345678909",
                "phone": "",
                "countryCode": null,
                "prov": "广东省",
                "city": "深圳",
                "street": "粤海街道",
                "address": "粤美特大厦",
                "taxNumber": "1234567889"
            },
            "receiver": {
                "name": "高渐离",
                "company": "天美工作室",
                "postCode": "518000",
                "mailBox": "ant_li@qq.com",
                "mobile": "12345678909",
                "phone": "",
                "countryCode": null,
                "prov": "广东省",
                "city": "深圳",
                "street": "粤海街道",
                "address": "粤美特大厦",
                "taxNumber": "1234567889"
            },
            "createOrderTime": null,
            "updateOrderTime": null,
            "sendStartTime": null,
            "sendEndTime": "2019-08-06 15:30:00",
            "payType": null,
            "goodsType": null,
            "length": null,
            "width": null,
            "height": null,
            "volume": 250.0,
            "weight": 1.0,
            "totalQuantity": 1,
            "itemsValue": 200.0,
            "priceCurrency": "RMB",
            "offerFee": 200000.0,
            "remark": "重要文件",
            "items": [
                {
                    "id": null,
                    "itemType": "文件",
                    "itemName": null,
                    "chineseName": "文件C",
                    "englishName": "文件E",
                    "number": 1,
                    "itemValue": "200000.00",
                    "priceCurrency": "RMB",
                    "desc": "文件",
                    "itemUrl": null
                }
            ],
            "orderNumber": 26666027030937625,
            "sortingCode": "110  110-120  130",
            "freight": null,
            "success": null,
            "reason": null,
            "sumFreight": "100",
            "orderStatus": null,
            "terminalDispatchCode": null,
            "lastCenterName":"深圳转运中心"
        }
    ]
}`
          ),

       //错误代码提示
        errcodeJson: [{code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
        {code:'145003097',msg:`${this.$t('apiTestDoc.时间范围非法')}`},
        {code:'145003102',msg:`${this.$t('apiTestDoc.页码非法')}`},
        {code:'145003098',msg:`${this.$t('apiTestDoc.超过数据限制')}`}]
      },


      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"serialNumber":["1598516207047"],"digest":"x+naV5ZQWEddcrRlxjX04Q==","customerCode":"J0086093125","command":1}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
       //错误代码提示
        errcodeJson: [{code:'145003031',msg:`${this.$t('apiTestDoc.业务参数签名失败')}`},
        {code:'145003097',msg:`${this.$t('apiTestDoc.时间范围非法')}`},
        {code:'145003102',msg:`${this.$t('apiTestDoc.页码非法')}`},
        {code:'145003098',msg:`${this.$t('apiTestDoc.超过数据限制')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
